export default __webpack_public_path__ + "static/media/thumbnail.fe610141.png";